import ChargebackService from '@services/resources/ChargebackService'
const serviceChargeback = ChargebackService.build();

const state = {
  items: [],
  currentPage: 1,
  perPage: 20,
  filter: '',
  totalRows: 1,
  loading: true,
  filterDate: {},
  typeFilterDate: null,
  noFilters: false
}
const getters = {
  getChargebacks: state => state.items,
  getChargebackCurrentPage: (state) => state.currentPage,
  getChargebackPerPage: (state) => state.perPage,
  getChargebackFilter: (state) => state.filter,
  getChargebackTotalRows: (state) => state.totalRows,
  getChargebackLoading: (state) => state.loading,
  getTypeFilterDate: (state) => state.typeFilterDate,
  getFilterDate: (state) => state.filterDate,
  getNoFilters: (state) => state.noFilters
}
const mutations = {
  setChargebacks(state, value) { state.items = value },
  setChargebacksCurrentPage(state, value) { state.currentPage = value },
  setChargebacksPerPage(state, value) { state.perPage = value },
  setChargebacksFilter(state, value) { state.filter = value },
  setChargebacksTotalRows(state, value) { state.totalRows = value },
  setChargebacksLoading(state, value) { state.loading = value },
  setFilterDate(state, value) { state.filterDate = value },
  setTypeFilterDate(state, value) { state.typeFilterDate = value },
  setNoFilters(state, value) { state.noFilters = value },
}
const actions = {
  updateChargebacksCurrentPage: ({ commit }, data) => commit('setChargebacksCurrentPage', data),
  updateChargebacksPerPage: ({ commit }, data) => commit('setChargebacksPerPage', data),
  updateChargebacksFilter: ({ commit }, data) => commit('setChargebacksFilter', data),
  updateChargebacksTotalRows: ({ commit }, data) => commit('setChargebacksTotalRows', data),
  updateChargebacksLoading: ({ commit }, data) => commit('setChargebacksLoading', data),
  updateFilterDate: ({ commit }, data) => commit('setFilterDate', data),
  updateTypeFilterDate: ({ commit }, data) => commit('setTypeFilterDate', data),
  updateNoFilters: ({ commit }, data) => commit('setNoFilters', data),

  async fetchChargebacks({ commit, state }) {
    commit('setChargebacksLoading', true)

    let data = {
      per_page: state.perPage,
      page: state.currentPage
    }

    // Aplicando filtros
    const filter = state.filter
    if (filter) {
      Object.keys(filter).forEach((key) =>
        (filter[key] == null || filter[key].length === 0) && delete filter[key]
      )
    }
    data = Object.assign(data, filter)

    const typeFilterDate = state.typeFilterDate;
    let filterDate = {};
    if (typeFilterDate === 'transaction_at') {
      filterDate = {
        transaction_at_start: state.filterDate.startDate,
        transaction_at_end: state.filterDate.endDate
      };
    } else if (typeFilterDate === 'chargeback_at') {
      filterDate = {
        chargedback_at_start: state.filterDate.startDate,
        chargedback_at_end: state.filterDate.endDate
      };
    }

    data = Object.assign(data, filterDate)

    serviceChargeback
      .search(data)
      .then((resp) => {
        commit('setChargebacks', resp.data)
        commit('setChargebacksTotalRows', resp.total || 1)
        commit('setChargebacksCurrentPage', resp.current_page || 1)
        commit('setChargebacksLoading', false)
      })
      .catch(err => console.error(err))
      .finally(() => { commit('setChargebacksLoading', false) })
  },

  // Upload do arquivo CSV
  async uploadFile({ commit, dispatch }, data) {
    commit('setChargebacksLoading', true)
    serviceChargeback
      .create(data, null, '/upload')
      .then((resp) => {
        dispatch('fetchChargebacks');
      })
      .catch(err => console.error(err))
      .finally(() => { commit('setChargebacksLoading', false) })
  },


  async updateStatus({ commit, dispatch }, data) {
    commit('setChargebacksLoading', true)
    serviceChargeback
      .update(data)
      .then((res) => {
        dispatch('fetchChargebacks');
      })
      .catch(err => console.error(err))
      .finally(() => { commit('setChargebacksLoading', false) })
  }

}

export {
  state,
  getters,
  mutations,
  actions
}
